import React from "react";

/**
 * Simple radar chart (SVG). dimensions: [{ label, score (0..1) }, ...]
 */
export default function PersonalityRadar({ dimensions = [], size = 220 }) {
  const n = dimensions.length;
  if (n < 3) return null;
  const cx = size / 2;
  const cy = size / 2;
  const radius = size / 2 - 24;
  const angle = (i) => (Math.PI * 2 * i) / n - Math.PI / 2;

  const points = dimensions
    .map((d, i) => {
      const r = radius * Math.max(0.05, Math.min(1, d.score || 0));
      return `${cx + r * Math.cos(angle(i))},${cy + r * Math.sin(angle(i))}`;
    })
    .join(" ");

  const grid = [0.25, 0.5, 0.75, 1].map((k) => {
    const p = dimensions
      .map((_, i) => `${cx + radius * k * Math.cos(angle(i))},${cy + radius * k * Math.sin(angle(i))}`)
      .join(" ");
    return <polygon key={k} points={p} fill="none" stroke="#e4e4e7" strokeWidth="1" />;
  });

  return (
    <div className="w-full" data-testid="personality-radar">
      <svg viewBox={`0 0 ${size} ${size}`} className="w-full h-auto">
        {grid}
        {dimensions.map((_, i) => (
          <line
            key={i}
            x1={cx}
            y1={cy}
            x2={cx + radius * Math.cos(angle(i))}
            y2={cy + radius * Math.sin(angle(i))}
            stroke="#e4e4e7"
            strokeWidth="1"
          />
        ))}
        <polygon points={points} fill="#09090b" fillOpacity="0.15" stroke="#09090b" strokeWidth="2" />
        {dimensions.map((d, i) => {
          const lx = cx + (radius + 14) * Math.cos(angle(i));
          const ly = cy + (radius + 14) * Math.sin(angle(i));
          return (
            <text
              key={i}
              x={lx}
              y={ly}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="10"
              fontFamily="JetBrains Mono, monospace"
              fill="#3f3f46"
              className="uppercase"
            >
              {(d.label || d.key).slice(0, 12)}
            </text>
          );
        })}
      </svg>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-3">
        {dimensions.map((d) => (
          <div key={d.key || d.label} className="flex items-center justify-between text-xs">
            <span className="text-zinc-600">{d.label || d.key}</span>
            <span className="font-mono text-zinc-950">{Math.round((d.score || 0) * 100)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
